// extracted by mini-css-extract-plugin
export default {"form":"SetLimitForm_form--xZF","submitButton":"SetLimitForm_submitButton--DJz","wrapper":"SetLimitForm_wrapper--Ua6","wrapperPopover":"SetLimitForm_wrapperPopover--KKN"};